import React from "react";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import { StyledCardSection } from "./styles";
const ProjectClientDetails = ({ formik, isReadOnlyMode }) => {
  const {
    clientName,
    clientAddress,
    clientManagerName,
    clientMangerTitle,
    clientManagerEmail,
    clientManagerPhone,
  } = formik.values;
  return (
    <StyledCardSection>
      <h1 className="tma_section-title">{translate("labels.client")}</h1>
      <div className="tma-form_field_content">
        <div className="tma_form-control">
          <Input
            id={"clientName"}
            name="clientName"
            labelText={translate("labels.clientName")}
            value={clientName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={{ maxLength: 100 }}
            error={
              formik.touched.clientName &&
              Boolean(formik.errors.clientName)
            }
            helperText={
              formik.touched.clientName && formik.errors.clientName
            }
            disabled={isReadOnlyMode}
          />
        </div>
        <div className="tma_form-control tma_align_label">
          <Input
            id="clientAddress"
            name="clientAddress"
            showInfoToolTip={false}
            labelText={translate("labels.clientAddress")}
            value={clientAddress}
            onChange={formik.handleChange}
            inputProps={{ maxLength: 150 }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.clientAddress &&
              Boolean(formik.errors.clientAddress)
            }
            helperText={
              formik.touched.clientAddress && formik.errors.clientAddress
            }
            disabled={isReadOnlyMode}
          />
        </div>
        <div className="tma_form-control"></div>
      </div>
      <div className="form_card">
        <h1 className="tma_section-subtitle">{translate("labels.managerFormTitle")}</h1>
        <div className="tma-form_field_content no-padding">
          <div className="tma_form-control tma_align_label">
            <Input
              id="clientManagerName"
              name="clientManagerName"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.managerName")}
              value={clientManagerName}
              inputProps={{ maxLength: 100 }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.clientManagerName &&
                Boolean(formik.errors.clientManagerName)
              }
              helperText={
                formik.touched.clientManagerName && formik.errors.clientManagerName
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
        <div className="tma-form_field_content">
          <div className="tma_form-control tma_min_input">
            <Input
              id="clientMangerTitle"
              name="clientMangerTitle"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.title")}
              value={clientMangerTitle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.clientMangerTitle &&
                Boolean(formik.errors.clientMangerTitle)
              }
              helperText={
                formik.touched.clientMangerTitle && formik.errors.clientMangerTitle
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="clientManagerEmail"
              name="clientManagerEmail"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.email")}
              value={clientManagerEmail}
              inputProps={{ maxLength: 100 }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.clientManagerEmail &&
                Boolean(formik.errors.clientManagerEmail)
              }
              helperText={
                formik.touched.clientManagerEmail && formik.errors.clientManagerEmail
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="clientManagerPhone"
              name="clientManagerPhone"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.phone")}
              value={clientManagerPhone}
              onChange={formik.handleChange}
              inputProps={{ maxLength: 15 }}
              onBlur={formik.handleBlur}
              error={
                formik.touched.clientManagerPhone &&
                Boolean(formik.errors.clientManagerPhone)
              }
              helperText={
                formik.touched.clientManagerPhone && formik.errors.clientManagerPhone
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
      </div>
    </StyledCardSection>
  );
};

export default ProjectClientDetails;
